module.exports = __webpack_public_path__ + "img/stars-2.6c92682d.png";